import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen flex-col justify-center bg-gray-50 font-lato text-gray-900" }
const _hoisted_2 = { class: "flex flex-1 flex-col px-8 pb-2 pt-6" }

import { onMounted } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';

import AppHeader from '../components/AppHeader.vue';
import AppBreadcrumbs from '../components/AppBreadcrumbs.vue';

import { useOfflineData } from '../composables/useOfflineData';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthorizedLayout',
  setup(__props) {

const { fetchAllData, isLoading, isDone } = useOfflineData();

onMounted(() => {
  fetchAllData();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_unref(ProgressSpinner), { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(AppHeader),
          _createElementVNode("main", _hoisted_2, [
            _createVNode(AppBreadcrumbs),
            (_unref(isDone))
              ? (_openBlock(), _createBlock(_component_RouterView, {
                  key: 0,
                  class: "flex-1"
                }))
              : _createCommentVNode("", true)
          ])
        ], 64))
  ]))
}
}

})